export function formatNumberPipe(input: any, nullableString: string = '') {
  const number = Number(input);
  if (isNaN(number)) {
    return nullableString;
  } else {
    return number.toLocaleString();
  }
}
